import { Injectable } from "@angular/core";
import{ Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { UUID } from 'angular2-uuid';

@Injectable()
export class ClaveUnicaService {
    public url;

    constructor(private _http: Http){
    }

    getToken(){
        let uuid = UUID.UUID();
        let headers = new Headers({
            'Content-type': 'application/json'
        })
        
        return this._http.get(`https://accounts.claveunica.gob.cl/openid/authorize?client_id=64ca79429cff44bf9fd1e7e4d1834ec6&redirect_uri=https%3A%2F%2F35.231.226.158%2Fclave_unica&response_type=code&scope=openid run name&state=${uuid}`, {headers: headers})
        .pipe(map(res => res));
    }
}